import { render, staticRenderFns } from "./uusi-kategoria.vue?vue&type=template&id=0b89841e&scoped=true&"
import script from "./uusi-kategoria.vue?vue&type=script&lang=ts&"
export * from "./uusi-kategoria.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-kategoria.vue?vue&type=style&index=0&id=0b89841e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89841e",
  null
  
)

export default component.exports